/**
 * Created by evgenijsenkevic on 27.08.2024
 * */

const AdminLocations = function () {
    cleverapps.EventEmitter.call(this);

    this.adminLocations = AdminLocations.ListBundleIds().map((bundleId) => new AdminLocation(bundleId));

    const selectedLocation = this.adminLocations.find((location) => location.locationId === cleverapps.meta.selectedLocationId()) || this.adminLocations[0];

    this.setActive(selectedLocation);
};

AdminLocations.prototype = Object.create(cleverapps.EventEmitter.prototype);
AdminLocations.prototype.constructor = AdminLocations;

AdminLocations.prototype.setActive = function (location) {
    if (this.activeLocation === location) {
        return;
    }

    if (this.activeLocation) {
        this.activeLocation.unselect();
    }

    cleverapps.meta.switchLocation(location.locationId);

    this.activeLocation = location;
    location.select();

    this.trigger("updateActiveLocation");
};

AdminLocations.getBaseUrl = function () {
    return cleverapps.isLocalhost() ? window.location.href.split("#")[0] : window.location.origin;
};

AdminLocations.prototype.play = function () {
    if (!this.activeLocation) {
        return;
    }

    const hash = cleverapps.toUrlHash({
        mode: "play_location",
        location: this.activeLocation.getLocationId()
    });

    connector.platform.openUrl(`${AdminLocations.getBaseUrl()}#${hash}`);
};

AdminLocations.prototype.edit = function () {
    if (!this.activeLocation) {
        return;
    }

    const locationId = this.activeLocation.getLocationId();
    const { locationType } = cleverapps.meta.getLocationMeta(locationId);

    const hash = cleverapps.toUrlHash({
        mode: "editor_location",
        location: this.activeLocation.name
    });

    if (locationType === "merge" && locationId !== "main" && !cleverapps.isLocalhost() && cleverapps.config.name !== "map2deditor") {
        connector.platform.openUrl(`https://map2deditor.cleverappssg.com/#${hash}`);
        return;
    }

    connector.platform.openUrl(`${AdminLocations.getBaseUrl()}#${hash}`);
};

AdminLocations.prototype.save = function (data) {
    const content = { ...this.activeLocation.getContent(), ...data };

    const author = cleverapps.git.getUserName();
    if (author) {
        const link = bundles[this.activeLocation.getBundleName()].jsons.map_json.resolve();
        const dirty = Boolean(cleverapps.git.local[link.originalPath()]);

        const prevUid = String(content.version || "").split(" ")[0];
        const uid = dirty && /^[a-z]{3}\d{3}$/.test(prevUid) ? prevUid : AdminLocations.nextVersionUid(content.version);

        const d = new Date();
        const date = `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${String(d.getFullYear()).slice(-2)}`;
        const time = `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
        const topCommand = typeof Editor !== "undefined" && Editor.currentEditor && Editor.currentEditor.getTopCommand && Editor.currentEditor.getTopCommand();
        content.version = [uid, date, time, author, topCommand].filter(Boolean).join(" ");
    }

    cleverapps.git.edit("location", {
        locationId: this.activeLocation.locationId,
        bundleId: this.activeLocation.getBundleName(),
        content
    });
};

AdminLocations.ListBundleIds = function () {
    return Object.keys(bundles).filter((bundleId) => bundles[bundleId].meta.location);
};

AdminLocations.nextVersionUid = function (prevVersion) {
    const prev = String(prevVersion || "").split(" ")[0];
    const match = /^([a-z]{3})(\d{3})$/.exec(prev);

    let letters = match ? match[1] : "aaa";
    let number = (match ? parseInt(match[2], 10) : 0) + 1;

    if (number > 999) {
        number = 1;
        letters = AdminLocations.incrementVersionLetters(letters);
    }

    return letters + String(number).padStart(3, "0");
};

AdminLocations.incrementVersionLetters = function (letters) {
    const chars = letters.split("");

    for (let i = chars.length - 1; i >= 0; i -= 1) {
        if (chars[i] === "z") {
            chars[i] = "a";
        } else {
            chars[i] = String.fromCharCode(chars[i].charCodeAt(0) + 1);
            break;
        }
    }

    return chars.join("");
};